import Alpine from 'alpinejs';
import * as Styles from './style.json';

Alpine.data('map', (config) => ({
    async init() {
        let mapHolderElement = this.$root.querySelector('.map__holder');

        // create a Google object and load the script
        ((g) => {
            let h,
                a,
                k,
                p = 'The Google Maps JavaScript API',
                c = 'google',
                l = 'importLibrary',
                q = '__ib__',
                m = document,
                b = window;
            b = b[c] || (b[c] = {});
            let d = b.maps || (b.maps = {}),
                r = new Set(),
                e = new URLSearchParams(),
                u = () =>
                    h ||
                    // eslint-disable-next-line no-async-promise-executor
                    (h = new Promise(async (f, n) => {
                        await (a = m.createElement('script'));
                        e.set('libraries', [...r] + '');
                        for (k in g)
                            e.set(
                                k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                                g[k]
                            );
                        e.set('callback', c + '.maps.' + q);
                        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                        d[q] = f;
                        a.onerror = () => (h = n(Error(p + ' could not load.')));
                        a.nonce = m.querySelector('script[nonce]')?.nonce || '';
                        m.head.append(a);
                    }));
            d[l]
                ? console.warn(p + ' only loads once. Ignoring:', g)
                : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
        })({
            key: config.googleMapsApiKey,
            v: 'weekly',
        });

        // create the map and marker
        // eslint-disable-next-line no-undef
        const { Map } = await google.maps.importLibrary('maps');
        // eslint-disable-next-line no-undef
        const { Marker } = await google.maps.importLibrary('marker');

        const map = new Map(mapHolderElement, {
            zoom: 14,
            center: config.markerLocation,
            gestureHandling: 'cooperative',
            styles: Styles.default,
            disableDefaultUI: true,
        });

        const image = {
            url: config.markerIconUri,
            // eslint-disable-next-line no-undef
            size: new google.maps.Size(36, 36),
            // eslint-disable-next-line no-undef
            scaledSize: new google.maps.Size(36, 36),
            // The origin for this image is (0, 0)
            // eslint-disable-next-line no-undef
            origin: new google.maps.Point(0, 0),
            // Anchor the pin tip to the map coordinates.
            // eslint-disable-next-line no-undef
            anchor: new google.maps.Point(18, 36),
        };

        // eslint-disable-next-line no-undef
        const marker = new Marker({
            position: config.markerLocation,
            // eslint-disable-next-line no-undef
            animation: google.maps.Animation.DROP,
            title: config.markerAddress,
            map: map,
            icon: image,
        });

        marker.addListener('click', () =>
            window.open(
                'https://www.google.com/maps/search/?api=1&query=' +
                    (encodeURIComponent(config.markerAddress) ||
                        config.markerLocation.lat + ',' + config.markerLocation.lng),
                '_blank'
            )
        );
    },
}));
